import { render } from "./HospitalEmergency.vue?vue&type=template&id=75252558&scoped=true"
import script from "./HospitalEmergency.vue?vue&type=script&lang=js"
export * from "./HospitalEmergency.vue?vue&type=script&lang=js"

import "./HospitalEmergency.vue?vue&type=style&index=0&id=75252558&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75252558"]])

export default __exports__